// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__UAA5M","sendOtp":"AuthorizeToLogin_sendOtp__1aRFo"};